import {Slot} from '@models/slot.model';
import {TrayType} from "@models/enums/tray-type.enum";

export class Tray {
    public id: number;
    public name: number;
    public slots: Slot[];
    public trayType: TrayType;
    public disabled: boolean;

    constructor(tray: any = {}) {
        this.id = tray.id || 0;
        this.name = tray.name;
        this.slots = tray.slots ? tray.slots.map((slot) => new Slot(slot)) : [];
        this.trayType = tray.type;
        this.disabled = tray.disabled || false;
    }

    get type() {
        return 'tray';
    }
}
